import _ from 'lodash'
import { Location, Route } from 'vue-router'

export function keepQueries(to: Route, from: Route): Location | null {
  /**
   * ルーティングごとに設定されている meta は、ルートのルーティングオブジェクトには入らず、
   * 個別の matched 配下からしか参照できない模様.
   * @see https://v3.router.vuejs.org/ja/guide/advanced/meta.html v3
   * @see https://router.vuejs.org/guide/advanced/meta.html v4からは、ルートオブジェクトから子のmetaを参照できる模様
   */
  const queriesShouldBeKeeped: '*' | string[] = from
    .matched
    .map(m => m.meta.queriesToBeKept as ('*' | string[] | undefined))
    .find(q => q !== undefined) || []

  console.log({ to, from, queriesShouldBeKeeped })

  if (queriesShouldBeKeeped === '*') {
    const next = {
      path: to.path,
      params: to.params,
      hash: to.hash,
      query: { ...from.query, ...to.query }, // 重複は、遷移時に明示的に指定されている方を優先
    }

    return _.isEqual(next.query, to.query) ? null : next // 遷移先もワイルドカード指定があったときの無限ループ回避
  }

  if (queriesShouldBeKeeped.length === 0) {
    return null
  }

  const nextQuery = queriesShouldBeKeeped.reduce(
    (prev: object, key: string) => ({
      ...prev,
      [key]: from.query[key],
    }),
    to.query
  )

  if (_.isEqual(nextQuery, to.query)) {
    // 遷移先もクエリ維持指定があったときの無限ループ回避
    return null
  }

  return {
    path: to.path,
    params: to.params,
    hash: to.hash,
    query: nextQuery,
  }
}
